import { z } from "zod";

/**
 * Assignment status schema
 * Tracks Graph API assignment results
 */
export const AssignmentStatusSchema = z.object({
  lastUpdated: z.string().optional(), // ISO date
  totalAssigned: z.number().optional(),
  userAssignments: z
    .object({
      succeeded: z.number(),
      failed: z.number(),
      pending: z.number()
    })
    .optional(),
  groupAssignments: z
    .object({
      succeeded: z.number(),
      failed: z.number(),
      pending: z.number()
    })
    .optional(),
  failedAssignments: z
    .array(
      z.object({
        target: z.string(), // Email or group ID
        type: z.enum(["user", "group"]),
        error: z.string(),
        timestamp: z.string()
      })
    )
    .optional()
});

export type AssignmentStatus = z.infer<typeof AssignmentStatusSchema>;
